var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8902 16.957H29.0001V2.65384C28.9988 2.21475 28.8234 1.7941 28.5125 1.48409C28.2015 1.17408 27.7803 0.999998 27.3412 1H10.5573C10.1182 0.999998 9.69702 1.17408 9.38607 1.48409C9.07512 1.7941 8.89976 2.21475 8.89844 2.65384V16.957H16.6264",
    stroke: "#343434",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.48 16.957H23.0309",
    stroke: "#343434",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01969 16.9566H2.92948C2.41862 16.9566 1.92861 16.754 1.5669 16.3933C1.2052 16.0325 1.00133 15.543 1 15.0322V9.47927C0.999495 9.14594 1.07491 8.81687 1.22051 8.51703L2.90442 5.07404L3.47074 3.92638C3.60738 3.64459 3.82121 3.4074 4.08737 3.24238C4.35353 3.07736 4.66108 2.9913 4.97423 2.99421H8.89834V16.9566H6.89368",
    stroke: "#343434",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.0701L6.01163 9.01799V5.08887H2.90442",
    stroke: "#343434",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.0957H2.87936",
    stroke: "#343434",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89844 14.0957H29.0001",
    stroke: "#343434",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9607 18.8873C26.0264 18.8873 26.8902 18.0234 26.8902 16.9578C26.8902 15.8922 26.0264 15.0283 24.9607 15.0283C23.8951 15.0283 23.0312 15.8922 23.0312 16.9578C23.0312 18.0234 23.8951 18.8873 24.9607 18.8873Z",
    stroke: "#343434",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5506 18.8873C19.6162 18.8873 20.4801 18.0234 20.4801 16.9578C20.4801 15.8922 19.6162 15.0283 18.5506 15.0283C17.485 15.0283 16.6211 15.8922 16.6211 16.9578C16.6211 18.0234 17.485 18.8873 18.5506 18.8873Z",
    stroke: "#343434",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94901 18.8873C6.01463 18.8873 6.87849 18.0234 6.87849 16.9578C6.87849 15.8922 6.01463 15.0283 4.94901 15.0283C3.88339 15.0283 3.01953 15.8922 3.01953 16.9578C3.01953 18.0234 3.88339 18.8873 4.94901 18.8873Z",
    stroke: "#343434",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckVector);
export default __webpack_public_path__ + "static/media/truck_vector.e39e5dc2d8ef34763c23a4ef4df3d96b.svg";
export { ForwardRef as ReactComponent };